module.exports = __webpack_public_path__ + "static/media/company.5a657f6f.jpg";